import React, { useEffect, useState } from 'react';
import { ReactComponent as VerifyAccountIcon } from 'assets/icons/verify-account.svg';
import AuthLayout from './auth-layout';
import AuthService from 'services/auth.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { useLocation } from 'react-router-dom';
import { getLocationOrigin, handleApiError } from 'utils/functions';
const ConfirmYourMail = () => {
  const location = useLocation();
  const email = location.state?.email;
  const [timeLeft, setTimeLeft] = useState(30);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (timeLeft > 0) {
        setTimeLeft((prev) => prev - 1);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  const resendMail = async () => {
    setTimeLeft(30);
    const payload = {
      dashboard_link: getLocationOrigin() + '/auth/reset-password',
      email
    };
    try {
      const res = await AuthService.forgotPassword(payload);
      if (res) {
        toast(<ToastMessage type='success' message={'Link has been resent'} />);
      }
    } catch (err) {
      handleApiError(err);
    }
  };
  return (
    <div>
      <AuthLayout
        title={'Confirm your email'}
        onConfirmText='Resend'
        disabled={timeLeft > 0}
        onConfirm={resendMail}>
        <div className='mx-auto'>
          <div className='text-sm'>
            <p className='text-[#6F7376]  mt-[-24px] mb-6'>
              A reset link has been sent to
              <span className='text-[#0080E5] text-base font-medium'> {email} </span>
              Please check your email and click the link to confirm
            </p>
            <VerifyAccountIcon />

            <p className='text-[#3FB827] mt-6'>
              Didn’t receive email?
              {timeLeft === 0 ? null : (
                <span className='text-[#2E3031] pl-1 text-medium cursor-pointer'>
                  Resend in {timeLeft} seconds
                </span>
              )}
            </p>
          </div>
        </div>
      </AuthLayout>
    </div>
  );
};

export default ConfirmYourMail;
